import type { Activity, ActivityChannel, ActivityDirection, ActivityTarget } from "../../lib/types";

/** Sprint 14 — shared display helpers for Activity rows (ActivityPanel + RowActivitySection). */

export const CHANNEL_ICON: Record<ActivityChannel, string> = {
  email: "ti-mail",
  call: "ti-phone",
  meeting: "ti-users",
  note: "ti-note",
  message: "ti-message",
  file_share: "ti-file-export",
  system: "ti-settings-bolt",
};

export const CHANNEL_LABEL: Record<ActivityChannel, string> = {
  email: "Email",
  call: "Call",
  meeting: "Meeting",
  note: "Note",
  message: "Message",
  file_share: "File share",
  system: "System",
};

/** Arrow glyph for direction: inbound ←, outbound →, internal ↔. */
export const DIRECTION_ICON: Record<ActivityDirection, string> = {
  inbound: "ti-arrow-left",
  outbound: "ti-arrow-right",
  internal: "ti-arrows-left-right",
};

export const CHANNEL_OPTIONS: ActivityChannel[] = [
  "email", "call", "meeting", "note", "message", "file_share", "system",
];

/** The headline "regarding" target — the primary one if marked, else the first. */
export function primaryTarget(activity: Activity): ActivityTarget | null {
  return activity.regarding.find((r) => r.primary) ?? activity.regarding[0] ?? null;
}

/** A short label for a regarding target chip. */
export function targetLabel(t: ActivityTarget): string {
  if (t.kind === "entity") return `${t.type ?? "record"} ${t.id}`;
  return t.id;
}

/** A short actor display string. */
export function actorLabel(activity: Activity): string {
  if (activity.actor_label) return activity.actor_label;
  if (activity.actor_id) return activity.actor_id;
  return activity.actor_kind;
}
